import type { ReactNode } from "react";

import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { Heading } from "@/components/ui/heading";
import { SidebarTrigger } from "@/components/ui/sidebar";

function SectionTitle({
  children,
  actions,
  breadcrumb,
}: {
  children: ReactNode;
  actions?: ReactNode;
  breadcrumb?: ReactNode;
}) {
  return (
    <div className="flex items-center justify-between mb-3 min-w-0 gap-4">
      <div className="flex items-start gap-2 min-w-0">
        <SidebarTrigger className="inline-flex md:hidden" />
        <div className="flex flex-col gap-1 min-w-0">
          {breadcrumb && <Breadcrumbs>{breadcrumb}</Breadcrumbs>}
          <Heading level={1} className="truncate">
            {children}
          </Heading>
        </div>
      </div>
      {actions}
    </div>
  );
}

function SectionSubtitle({
  children,
  actions,
}: {
  children: string;
  actions?: ReactNode;
}) {
  return (
    <div className="flex items-center justify-between border-b pb-1 mb-1">
      <Heading level={2}>{children}</Heading>
      {actions}
    </div>
  );
}

const Namespace = Object.assign(
  {},
  {
    Title: SectionTitle,
    Subtitle: SectionSubtitle,
  },
);

export { Namespace as Section };
